/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Credits_DescriptionInputs */

const en_settings_billing_credits_description = /** @type {(inputs: Settings_Billing_Credits_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your available credit balance`)
};

/**
* | output |
* | --- |
* | "Your available credit balance" |
*
* @param {Settings_Billing_Credits_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_credits_description = /** @type {((inputs?: Settings_Billing_Credits_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Credits_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_credits_description(inputs)
});
export { settings_billing_credits_description as "settings.billing.credits_description" }